import angular from 'angular';
import 'ng-file-upload';
import 'angular-bootstrap';
import 'angular-sanitize';
import 'ui-select';
import './evaluationsServices';

const evaluationsControllers = angular.module('applicationModule.evaluationsControllers', [
    'ngSanitize',
    'applicationModule.evaluationsServices',
    'flow',
    'ngFileUpload',
    'ui.bootstrap'
]);

evaluationsControllers.controller('EvaluationsController', ['$scope', '$rootScope', 'Evaluations', '$state', '$stateParams', 'growl', 'Permissions', function ($scope, $rootScope, Evaluations, $state, $stateParams, growl, Permissions) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('evaluations');
    $scope.application_id = $stateParams.application_id;
    const token = localStorage.getItem('appsoup:userToken');

    $scope.isLoading = true;
    $scope.disableLoad = true;
    $scope.loadDisable = false;

    $scope.flowInit = {
        target: '/api/app/evaluations',
        testChunks: false,
        singleFile: true,
        headers: {
            'Authorization': 'Bearer ' + token.toString()
        }
    };

    const getEvaluations = function () {
        Evaluations.get($scope.application_id).then(function (result) {
            let data = result.data;

            if (data.data) {
                $scope.isLoading = true;
                $scope.disableLoad = true;
                $scope.evaluations = data.data;
            } else {
                growl.error('MODULES.EVALUATIONS.ERROR.' + data.error);
            }
        })
            .finally(function () {
                $rootScope.doingResolve = false;
                $scope.isLoading = false;
                $scope.disableLoad = false;
            });
    };

    $scope.evaluations = [];

    getEvaluations();

    $scope.badRows = {};
    $scope.rowsAdded = null;

    $scope.fileSuccess = function (file, messageStr) {
        growl.success('MODULES.EVALUATIONS.SUCCESS.ADDED');

        $scope.badRows = angular.fromJson(messageStr).badRows;
        $scope.rowsAdded = angular.fromJson(messageStr).rowsAdded;

        getEvaluations();

        file.cancel();
    };
}]);

export default evaluationsControllers;
